import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Header from "@/components/Layout/Header";
import BottomNav from "@/components/Layout/BottomNav";
import ScrollAd from "@/components/Common/ScrollAd";
import ProtectedRoute from "@/components/Common/ProtectedRoute";

import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Search from "@/pages/Search";
import ProductDetail from "@/pages/ProductDetail";
import ShopPage from "@/pages/ShopPage";
import Favorites from "@/pages/Favorites";
import Profile from "@/pages/Profile";
import Orders from "@/pages/Orders";  // kept in code for future; route removed from UI
import CreateShop from "@/pages/CreateShop";
import ProductForm from "@/pages/ProductForm";
import MerchantDashboard from "@/pages/MerchantDashboard";
import AdminPanel from "@/pages/AdminPanel";
import Notifications from "@/pages/Notifications";
import Messages from "@/pages/Messages";

function Layout() {
  return (
    <div className="min-h-screen bg-[#FCFCF9] text-[#1A1918]">
      <Header />
      <main className="safe-bottom">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recherche" element={<Search />} />
          <Route path="/connexion" element={<Login />} />
          <Route path="/inscription" element={<Register />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
          <Route path="/produit/:id" element={<ProductDetail />} />
          <Route path="/produit/:id/modifier" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
          <Route path="/boutique/:id" element={<ShopPage />} />
          <Route path="/favoris" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
          <Route path="/profil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/vendre" element={<ProtectedRoute><CreateShop /></ProtectedRoute>} />
          <Route path="/creer-produit" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
          <Route path="/tableau-bord" element={<ProtectedRoute><MerchantDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPanel /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        </Routes>
      </main>
      <BottomNav />
      <ScrollAd />
      <Toaster position="top-center" richColors theme="system" />
    </div>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
